<template>
    <div class="sidebar" ref="sidebar">
        <ul class="nav nav-tabs" v-if="$route.name === 'PISearch' || $route.name === 'list' || $route.name === 'charts' || $route.name === 'map' || $route.name === 'POSearch'">
            <li class="nav-item">
                <a class="nav-link nav-link-list" href @click.prevent="changeView('')" :class="{'disabled': !searchMeta || (searchMeta && searchMeta.total <= 0), 'active': $route.name === 'list'}" rel="noopener">
					<i class="nav-icon fas fa-list fa-2x"></i>
                    <span class="link-text">List</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link nav-link-charts" :class="{'disabled': !searchMeta || (searchMeta && searchMeta.total <= 0), 'active': $route.name === 'charts'}" href @click.prevent="changeView('charts')" rel="noopener">
					<i class="far fa-chart-bar fa-2x"></i>
                    <span class="link-text">Charts</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link nav-link-map" href @click.prevent="changeView('map')" :class="{'disabled': !searchMeta || (searchMeta && searchMeta.total <= 0), 'active': $route.name === 'map'}" rel="noopener">
				<i class="fa fa-map-marker-alt fa-2x"></i>
                    <span class="link-text d-block">Map</span>
                </a>
            </li>
        </ul>
        <div v-if="facetError" class="error-message">{{facetErrorMsg}}</div>
        <div v-if="facetLoader" class="loading"><span class="loader">Loading...</span></div>
        <div id="facets" v-if="searchFacetData" :class="{'loading': facetLoader}">

            <h2 class="facets-header fh-small"><b-link class="collapsed" v-b-toggle.faceted-items rel="noopener">
				<i class="fas fa-filter nav-icon-filter"></i>Filters<span class="on"></span><span class="off"></span></b-link>
            </h2>
            <div class="mb-2">
                <!-- <h2 class="facets-header fh-full">Refine <span v-if="$route.name !== 'publications'">Projects</span>  By</h2> -->
                <h2 class="facets-header fh-full">Filters</h2>
            </div>
            <b-collapse :visible="breakpoints.gt.lg" class="facets-scroll collapse" ref="facetsScroll" id="faceted-items">
                <div v-if="$route.name === 'publications'">
                    <ul>
                        <template v-for="(facet, facetIndex) in publicationsFacetData.facets"  v-if="publicationsFacetData && publicationsFacetData.facets  && publicationsFacetData.facets[0].values && publicationsFacetData.facets[0].values.length > 0">
                            <li  :key="facet.name" v-if="facet.values.length > 0">

                                <b-button v-b-toggle="'collapse-pub-' + index + '-' + facetIndex" variant="link">
                                    <i class="fas fa-angle-down"></i> {{facet.display}}
                                    <button class="btn fac-clear" v-if="facetCriteria && facetCriteria[facet.name].length > 0" @click.prevent="clearSelections(facet.name, $event)">CLEAR</button>
                                </b-button>
                                <b-collapse  :id="'collapse-pub-' + index + '-' + facetIndex">
                                    <ul class="ms-4 ps-1" v-if="facet.values && facetCriteria">
                                        <li v-for="value in returnFirstLevelFacets(facet.values)" :key="facet.name + '-' + value.display">
                                            <div class="custom-checkbox form-check form-check-inline mt-1 ">
                                                <input :name="facet.name + '-' + value.display" :id="facet.name + '-' + value.display" type="checkbox" v-model="facetCriteria[facet.name]" class="form-check-input" :value="value.value" @click="checkCheck(facet, value)" :indeterminate.prop="isIndeterminate(facet, value)">
                                                <label :for="facet.name + '-' + value.display" class="form-check-label">
                                                    <span class="label-text">{{value.display}}</span>
                                                    <span class="label-count">({{value.count | addCommas}})</span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </b-collapse>

                            </li>
                        </template>
                        <li>
                            <b-button v-b-toggle="'collapse-pub-disc'" variant="link">
                                <i class="fas fa-angle-down"></i> Disclaimer
                            </b-button>
                            <b-collapse  id="collapse-pub-disc">
                                <div class="px-3 small ">Publications are associated with projects, but cannot be identified with any particular year of the project or fiscal year of funding. This is due to the continuous and cumulative nature of knowledge generation across the life of a project and the sometimes long and variable publishing timeline. Similarly, for multi-component projects, publications are associated with the parent core project and not with individual sub-projects.</div>
                            </b-collapse>
                        </li>
                    </ul>
                </div>

                <div v-if="$route.name === 'publications'">
                    <h2 class="facets-header fh-full">Project Filters</h2>
                </div>
                <div>
                    <ul v-if="searchFacetData.facets">
                        <li v-if="facetCriteria && facetCriteria.is_active_projects !== undefined && searchType === 'Smart'">
                            <div class="custom-checkbox form-check form-check-inline mt-1 ms-2  is-active">
                                <input name="active_projects" id="active_projects" type="checkbox" :disabled="(!searchMeta || (searchMeta && searchMeta.total <= 0)) && facetCriteria.is_active_projects === undefined" v-model="facetCriteria['is_active_projects']" class="form-check-input" value="true" @click="checkCheck()">
                                <label for="active_projects" class="form-check-label">
                                    <span class="label-text">Active Projects</span>
                                </label>
                            </div>
                        </li>
                        <template v-for="(facet, facetIndex) in searchFacetData.facets">
                            <li v-if="facet.values.length > 0" :key="facet.name">

                                <b-button v-b-toggle="'collapse-' + index + '-' + facetIndex" variant="link">
                                    <i class="fas fa-angle-down"></i> {{facet.display}}
                                    <button class="btn fac-clear" v-if="facetCriteria && facetCriteria[facet.name].length > 0" @click.prevent="clearSelections(facet.name, $event)">CLEAR</button>
                                </b-button>

                                <b-collapse :id="'collapse-' + index + '-' + facetIndex" :visible="(facetCriteria && facetCriteria[facet.name].length > 0)">
                                    <ul class="ms-4 ps-1" v-if="facet.values && facetCriteria">
                                        <li v-for="value in returnFirstLevelFacets(facet.values)" :key="facet.name + '-' + value.display">
                                            <div class="custom-checkbox form-check form-check-inline mt-1 ">
                                                <input :name="facet.name + '-' + value.display" :id="facet.name + '-' + value.display" type="checkbox" v-model="facetCriteria[facet.name]" class="form-check-input" :value="value.value" @click="checkCheck(facet, value)" :indeterminate.prop="isIndeterminate(facet, value)">
                                                <label :for="facet.name + '-' + value.display" class="form-check-label">
                                                    <span class="label-text">{{value.display}}</span>
                                                    <span class="label-count">({{value.count | addCommas}})</span>

                                                     <b-link
                                                        v-if="value.children_values && value.children_values.length !== 0"
                                                        v-b-toggle="'collapse-' + index + '-' + facetIndex + value.value + 'children'"
                                                        variant="link"
                                                        :aria-expanded="facetIndex == 0 && index == 0 ? true : false"
                                                        :aria-controls="'#collapse-' + index + '-' + facetIndex + value.value + 'children'"
                                                        class="ms-2"  rel="noopener"
                                                    >
                                                        <i class="fas fa-angle-down"></i>
                                                        <span class="sr-only">expand</span>
                                                    </b-link>
                                                </label>
                                            </div>
                                            <b-collapse v-if="value.children_values && value.children_values.length !== 0"
                                                    :visible="(facetCriteria && facetCriteria[facet.name].length > 0 && facetCriteria[facet.name].indexOf(value.value) !== -1)"
                                                    :id="'collapse-' + index + '-' + facetIndex + value.value + 'children'">
                                                <ul  class="ms-4 ps-1">
                                                    <li v-for="child in returnSecondLevelFacets(facet.values, value.value)" :key="facet.name + '-' + child.display">
                                                    <!-- <li v-for="value in facet.values" :key="facet.name + '-' + child.display"> -->

                                                        <div class="custom-checkbox form-check form-check-inline mt-1 ">
                                                            <input :name="facet.name + '-' + child.display" :id="facet.name + '-' + child.display" type="checkbox" v-model="facetCriteria[facet.name]" class="form-check-input" :value="child.value" @click="checkCheck(facet, child)">
                                                            <label :for="facet.name + '-' + child.display" class="form-check-label">
                                                                <span class="label-text">{{child.display}}</span>
                                                                <span class="label-count">({{child.count | addCommas}})</span>
                                                            </label>
                                                        </div>

                                                    </li>
                                                </ul>
                                            </b-collapse>

                                        </li>
                                    </ul>
                                </b-collapse>

                            </li>
                        </template>
                    </ul>
                </div>
            </b-collapse>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import breakpoints from '@/shared/breakpoints.utils.js';
    import bus from '@/shared/event-bus.js';
    export default {
        name: 'facets',
        data: function () {
            return {
                fixedPosition: false,
                index: 0,
                facetCriteria: null,
                facetCriteriaOrg: {},
                pubFacetCriteria: null,
                updateProjectSearchResultsTimeout: null,
                pubFacetCriteria: null,
                facetError: false,
                loadingPubFacets: false,
                facetErrorMsg: 'An error has occurred. Please try again after sometime.',
                facetLoader: false,
                publicationCountNote : ""
            }
        },
        computed: {
            ...mapGetters([
                'searchMeta',
                'searchFacetCriteria',
                'searchFacetData',
                'publicationsFacetData',
                'searchResults',
                'searchType',
                'searchCriteria'
            ]),
            breakpoints: () => breakpoints.screen
        },
        mounted () {
            bus.$off('init:facet');
            bus.$on('init:facet', () => {
                this.initFacets();
            });
            if ((this.searchMeta && !this.searchMeta.search_id) || !this.$route.params.search_id) {
                if (this.$route.name !== 'PISearch' && this.$route.name !== 'POSearch' && this.$route.name !== 'smartSearch') {
                    this.$router.push({ path: '/' });
                }
                this.facetLoader = true;
            } else if (this.$route.name === 'map') {
                // defer loading of facets on map page
                // console.log('facets waiting..............');
                return false;
            } else {
                this.facetError = false;
                if (!this.searchFacetData) {
                    this.facetLoader = true;
                    this.facetCriteria = null;
                    this.facetCriteriaOrg = {};
                    this.getFacets(false);
                } else {
                    this.facetCriteria = copyData(this.$store.state.searchFacetCriteria);
                    this.updateURL();
                }
                if (this.facetCriteria) {
                    this.facetCriteria['publication_years'] = [];
                    if (this.searchType === 'Smart' && this.facetCriteria['is_active_projects'] === undefined) {
                        this.facetCriteria['is_active_projects'] = false;
                    }
                }
            }

        },
        beforeDestroy () {
            bus.$off('init:facet');
        },
        methods: {
            ...mapActions([
               'setSearchFacetCriteria',
               'setSearchFacetData',
               'setPublicationsFacetData',
               'setPublicationsFacetCriteria',
               'updateSearchResultsFacets',
               'setSelectedPerson'
            ]),
            addCommas (value) {
                return window.filters.addCommas(value);
            },
             setPublicationCountNote() {
               let pubCounts = 0;
               let facet = this.publicationsFacetData ? this.publicationsFacetData.facets[0] : null;
               if (facet !== null && this.facetCriteria !== null) {
                 for (let i = 0; i < facet.values.length; i++) {
                   if (this.facetCriteria[facet.name].indexOf(facet.values[i].value) !== -1) {
                     pubCounts += facet.values[i].count;
                   }

                   if (pubCounts > 0) {
                     this.publicationCountNote = window.addCommas(pubCounts) + (pubCounts > 0 ? " Publications" : " Publication");
                   } else {
                     this.publicationCountNote = "";
                   }
                   bus.$emit("publication_count", this.publicationCountNote);
                 }
               }
            },
            setSidebarHeight () {
                var resultArea = document.getElementsByClassName('searchResults'),
                    resultAreaOffset = resultArea && resultArea.length > 0 ? resultArea[0].offsetTop + 5 : 0,
                    scrollOffsetTop = this.$refs.facetsScroll ? this.$refs.facetsScroll.offsetTop : 0,
                    ResultsContainerOffsetTop = this.$parent.getResultsContainerOffsetTop(),
                    offset = 0;

                if (window.pageYOffset < ResultsContainerOffsetTop) {
                    offset = ResultsContainerOffsetTop - window.pageYOffset;
                }

                offset += scrollOffsetTop;

                this.$parent.getResultsContainerOffsetTop();

                if (this.$refs && this.$refs.sidebar) {
                    // if (this.$refs.sidebar.classList.contains('fixed-head')) {
                    if (this.$refs.facetsScroll && this.$refs.facetsScroll.style) {
                        // this.$refs.facetsScroll.style.height = 'calc(100vh - ' + this.$refs.facetsScroll.offsetTop + 'px)';
                        this.$refs.facetsScroll.style.height = 'calc(100vh - ' + offset + 'px)';
                    }
                    // } else {
                    //     if (this.$refs.facetsScroll) {
                    // //         this.$refs.facetsScroll.style.height = 'calc(100vh - ' + (this.$refs.facetsScroll.offsetTop - window.scrollY) + 'px)';
                    //         this.$refs.facetsScroll.style.height = 'auto';
                    //         this.$refs.facetsScroll.style.maxHeight = '100%';
                    //         // if (document.body.clientHeight < window.innerHeight) {
                    //         //     this.$refs.facetsScroll.style.maxHeight = (window.innerHeight - resultAreaOffset - this.$refs.facetsScroll.offsetTop) + 'px';
                    //         // }
                    //     }
                    // }
                }
            },
            initFacets () {
                this.facetError = false;
                this.setPublicationsFacetData(null);
                this.setPublicationsFacetCriteria(null);
                this.facetLoader = true;

                if (!this.searchFacetData) {
                    this.facetCriteria = null;
                    this.facetCriteriaOrg = {};
                    // this.getFacets(false);
                } else {
                    this.facetCriteria = copyData(this.$store.state.searchFacetCriteria);
                    //this.facetCriteriaOrg = copyData(this.$store.state.searchFacetCriteria);
                    // this.getPubFacets(false);
                    // this.updateURL();
                }

                if (this.searchCriteria) {
                    this.getFacets(false);
                } else {
                    this.awaitSearchCriteria();
                }

                if (this.facetCriteria) {
                    this.facetCriteria['publication_years'] = [];
                    if (this.searchType === 'Smart' && this.facetCriteria['is_active_projects'] === undefined) {
                        this.facetCriteria['is_active_projects'] = false;
                    }
                }
            },
            awaitSearchCriteria () {
                setTimeout(() => {
                    if (this.searchCriteria) {
                        this.getFacets(false);
                    } else {
                        this.awaitSearchCriteria();
                    }
                }, 500);
            },
            getFacets (changeCriteria) {
                // let URLFacets;
                if (this.$route.query) {
                    this.$parent.parseFacetFiltersFromURL();
                    // URLFacets = this.$parent.parseFacetFiltersFromURL();

                    // console.log('URLFacets', URLFacets);

                    // if (!this.facetCriteria && URLFacets) {
                    //     this.facetCriteria = URLFacets;
                    // } else if (URLFacets) {
                    //     this.facetCriteria = Object.assign(this.facetCriteria, URLFacets);
                    //     // this.facetCriteria.concat(URLFacets);
                    // }

                    // console.log('facetCriteria', this.facetCriteria);
                }

                this.$parent.getSearchResultsFacets(changeCriteria, this.loadSearchResultsFacets);
            },
            getPubFacets (changeCriteria) {
                if (this.$route.name === 'publications') {
                    this.loadingPubFacets = true;
                    this.$parent.getPublicationsFacets(changeCriteria, this.loadPublicationsFacets);
                }
            },
            parseFacetData (data) {
                // cache variables for faster performance
                let dataLength = data.facets.length,
                    valuesLength,
                    lookupData,
                    i,
                    i2;

                for (i = 0; i < dataLength; i++) {
                    switch (data.facets[i].name) {
                        case 'fiscal_years':
                            // sort Fiscal Years descending by Year
                            data.facets[i].values.sort((a, b) => {
                                return b.value - a.value;
                            });

                            break;
                        case 'agencies':
                            // set up heirarchy from lookup data
                            if (this.$store.state.lookup.agencies) {
                                valuesLength = data.facets[i].values.length;

                                for (i2 = 0; i2 < valuesLength; i2++) {

                                    lookupData = this.$store.state.lookup.agencies.filter((item) => {
                                        return item.value === data.facets[i].values[i2].value;
                                    });

                                    if (lookupData.length !== 0) {
                                        data.facets[i].values[i2].parent_value = lookupData[0].parent_value;
                                        data.facets[i].values[i2].children_values = lookupData[0].children_values;
                                    }
                                }

                                // sort agencies facet alphabetically
                                data.facets[i].values.sort((a, b) => {
                                    let textA = a.display.toLowerCase(),
                                        textB = b.display.toLowerCase();

                                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                                });
                            }

                            break;
                    }
                }

                return data;
            },
            returnFirstLevelFacets (data) {
                return data.filter((item) => {
                    return !item.parent_value;
                });
            },
            returnSecondLevelFacets (data, parentValue) {
                return data.filter((item) => {
                    return item.parent_value === parentValue;
                });
            },
            isIndeterminate (facet, value) {
                let secondLevel = this.returnSecondLevelFacets(facet.values, value.value),
                    checkedTotal = 0;

                for (let i = 0; i < secondLevel.length; i++) {
                    if (this.facetCriteria[facet.name].indexOf(secondLevel[i].value) !== -1) {
                        checkedTotal++;
                    }
                }

                if (checkedTotal > 0 && checkedTotal !== secondLevel.length) {
                    return true;
                }

                return false;
            },
            checkCheck (facet, value) {
                let isChecked = false;

                setTimeout(() => {
                    if (facet) {
                        if (this.facetCriteria[facet.name].indexOf(value.value) !== -1) {
                            isChecked = true;
                        }

                        if (value.parent_value) {
                            let allChildrenOfParent = this.returnSecondLevelFacets(facet.values, value.parent_value),
                                allChecked = true,
                                checkedTotal = 0;

                            for (let i = 0; i < allChildrenOfParent.length; i++) {
                                // check if all siblings are checked
                                if (this.facetCriteria[facet.name].indexOf(allChildrenOfParent[i].value) === -1) {
                                    allChecked = false;
                                } else {
                                    checkedTotal++;
                                }
                            }

                            if (allChecked) {
                                if (this.facetCriteria[facet.name].indexOf(value.parent_value) === -1) {
                                    this.facetCriteria[facet.name].push(value.parent_value);
                                    if (!this.facetCriteriaOrg[facet.name]) {
                                        this.facetCriteriaOrg[facet.name] = [];
                                    }
                                    this.facetCriteriaOrg[facet.name].push(value);
                                }
                            } else if (this.facetCriteria[facet.name].indexOf(value.parent_value) !== -1) {
                                this.facetCriteria[facet.name].splice(this.facetCriteria[facet.name].indexOf(value.parent_value), 1);
                                if (this.facetCriteriaOrg[facet.name]) {
                                    this.facetCriteriaOrg[facet.name].splice(this.facetCriteria[facet.name].indexOf(value.parent_value), 1);
                                }
                                // indeterminent state
                                if (checkedTotal > 0) {

                                }
                            }
                        }

                        if (value.children_values && value.children_values.length !== 0) {
                            let allChildren = this.returnSecondLevelFacets(facet.values, value.value);

                            for (let i = 0; i < allChildren.length; i++) {
                                if (isChecked) {
                                    if (this.facetCriteria[facet.name].indexOf(allChildren[i].value) === -1) {
                                        this.facetCriteria[facet.name].push(allChildren[i].value);
                                        if (!this.facetCriteriaOrg[facet.name]) {
                                            this.facetCriteriaOrg[facet.name] = [];
                                        }
                                        this.facetCriteriaOrg[facet.name].push(allChildren[i]);
                                    }
                                } else {
                                    this.facetCriteria[facet.name].splice(this.facetCriteria[facet.name].indexOf(allChildren[i].value), 1);
                                    if (this.facetCriteriaOrg[facet.name]) {
                                        this.facetCriteriaOrg[facet.name].splice(this.facetCriteria[facet.name].indexOf(allChildren[i].value), 1);
                                    }
                                }
                            }

                        }

                        if (!value.children_values && !value.parent_value) {
                            if (isChecked) {
                                if (!this.facetCriteriaOrg[facet.name]) {
                                    this.facetCriteriaOrg[facet.name] = [];
                                }
                                this.facetCriteriaOrg[facet.name].push(value);
                            } else {
                                if (this.facetCriteriaOrg[facet.name]) {
                                    this.facetCriteriaOrg[facet.name].splice(this.facetCriteria[facet.name].indexOf(value.value), 1);
                                }
                            }
                        }
                    }
                  this.updateSearch(facet);
                  if (facet && facet.name === "publication_years") {
                    this.setPublicationCountNote();
                  }

                  // reset publication facet if current tab is not publication
                  if (this.$route.name !== 'publications') {
                    this.setPublicationsFacetData(null);
                  }
                }, 1);
            },
            loadSearchResultsFacets (data) {
                var self = this,
                    tempFacetIndex,
                    isExists = false,
                    orgData = copyData(data);

                this.facetLoader = false;
                if (!data.status) {
                    data = this.parseFacetData(data);

                    this.setSearchFacetData(data);

                    if (!this.facetCriteria) {
                        this.setSearchFacetCriteria(data);
                        this.$parent.parseFacetFiltersFromURL();
                        this.facetCriteria = copyData(this.$store.state.searchFacetCriteria);

                        if (window.firstLoadFacets) {
                            this.facetCriteria = Object.assign(this.facetCriteria, window.firstLoadFacets);
                            this.$store.state.searchFacetCriteria = Object.assign(this.$store.state.searchFacetCriteria, window.firstLoadFacets);

                            window.firstLoadFacets = null;
                        }
                    } else {
                        for (let item in this.facetCriteriaOrg) {
                            for (let i = 0; i < orgData.facets.length; i++) {
                                if (orgData.facets[i].name === item) {
                                    tempFacetIndex = i;
                                    break;
                                }
                            }
                            if (tempFacetIndex) {
                                for (let i = 0; i < this.facetCriteriaOrg[item].length; i++) {
                                    isExists = false;
                                    orgData.facets[tempFacetIndex].values.filter((val) => {
                                        if (val && this.facetCriteriaOrg[item][i] && val.value === this.facetCriteriaOrg[item][i].value) {
                                            isExists  = true;
                                            return;
                                        }
                                    });
                                    if (!isExists && this.facetCriteriaOrg[item][i]) {
                                        orgData.facets[tempFacetIndex].values.push({
                                            value: this.facetCriteriaOrg[item][i].value,
                                            display: this.facetCriteriaOrg[item][i].display,
                                            count: 0
                                        });
                                    }
                                }
                            }
                        }
                        data = this.parseFacetData(orgData);
                        this.setSearchFacetData(data);
                    }

                    if (window.firstLoadFacets) {
                        this.facetCriteria = Object.assign(this.facetCriteria, window.firstLoadFacets);
                        window.firstLoadFacets = null;
                    }
                    if (this.searchType === 'Smart' && this.facetCriteria['is_active_projects'] === undefined) {
                        this.facetCriteria['is_active_projects'] = false;
                    }
                } else {
                    this.setSearchFacetData(null);
                    this.setSearchFacetCriteria(null);
                    this.facetError = true;
                }

                document.addEventListener('scroll', function () {
                    self.setSidebarHeight();
                });

                setTimeout(() => {
                    this.setSidebarHeight();
                }, 1);
            },
            loadPublicationsFacets (data) {
                var self = this,
                    tempFacetIndex  = 0,
                    orgData = copyData(data),
                    isExists = false,
                    item = 'publication_years';

                this.loadingPubFacets = false;
                this.facetLoader = false;
                if (!data.status) {
                    if (data.facets) {
                        data = this.parseFacetData(data);

                        this.setPublicationsFacetData(data);

                        this.setPublicationsFacetCriteria(data);

                        if (!this.facetCriteria) {
                            this.facetCriteria = {};
                        }
                        if (!this.facetCriteria['publication_years']){
                            this.facetCriteria['publication_years'] = [];
                        }
                        if (this.facetCriteriaOrg && this.facetCriteriaOrg[item]) {
                            for (let i = 0; i < this.facetCriteriaOrg[item].length; i++) {
                                isExists = false;
                                orgData.facets[tempFacetIndex].values.filter((val) => {
                                    if (val && this.facetCriteriaOrg[item][i] && val.value === this.facetCriteriaOrg[item][i].value) {
                                        isExists  = true;
                                        return;
                                    }
                                });
                                if (!isExists && this.facetCriteriaOrg[item][i]) {
                                    orgData.facets[tempFacetIndex].values.push({
                                        value: this.facetCriteriaOrg[item][i].value,
                                        display: this.facetCriteriaOrg[item][i].display,
                                        count: 0
                                    });
                                }
                            }
                        }
                        data = this.parseFacetData(orgData);
                        this.setPublicationsFacetData(data);
                        this.setPublicationCountNote();
                    } else {
                        this.$parent.countLoader = false;
                        this.setPublicationsFacetData(null);
                        this.setPublicationsFacetCriteria(null);
                    }
                } else {
                    this.$parent.countLoader = false;
                    this.setPublicationsFacetData(null);
                    this.setPublicationsFacetCriteria(null);
                    this.facetError = true;
                }
            },
            generateQueryString () {
                var data = copyData(this.searchFacetCriteria),
                    // queryStr = '',
                    queryStrParam = {};

                for (let field in data) {
                    switch (field) {
                        case 'fiscal_years':
                            if (data[field].length > 0) {
                                // queryStr += '$fy;' + data[field].join(';');
                                queryStrParam['fy'] = data[field].join(';');
                            }
                            break;
                        case 'org_names':
                            if (data[field].length > 0) {
                                // queryStr += '$org;' + data[field].join(';');
                                queryStrParam['org'] = data[field].join(';');
                            }
                            break;
                        case 'principal_investigators':
                            if (data[field].length > 0) {
                                // queryStr += '$PI;' + data[field].join(';');
                                queryStrParam['PI'] = encodeURI(data[field].join(';'));
                            }
                            break;
                        case 'is_active_projects':
                            if (data[field]) {
                                // queryStr += '$projects;Active';
                                queryStrParam['projects'] = 'Active';
                            }
                            break;
                        default:
                            if (data[field].length > 0) {
                                // queryStr += '$' + field + ';' + data[field].join(';');
                                queryStrParam[field] = data[field].join(';');
                            }
                    }
                }
                return queryStrParam;
            },
            updateSearch (facet, timeout) {
                var facetToQueryStr = '';

                if (!timeout) {
                    timeout = 500;
                }

                this.facetError = false;

				gtag('event','Click', {
					'event_category': 'Search Results Facets',
					'event_label': 'Check/uncheck facet - ' + (facet ? facet.display : 'Is Active Project'),
					'value': 'Check/uncheck facet - ' + (facet ? facet.display : 'Is Active Project')
				});	

                // window.scrollTo(0, 0);
                if (this.$parent.scrollToResultsTop) {
                    this.$parent.scrollToResultsTop();
                }

                this.updateSearchResultsFacets(this.facetCriteria);

                if (this.updateProjectSearchResultsTimeout) {
                    clearTimeout(this.updateProjectSearchResultsTimeout);
                }

                this.updateURL();
                this.updateProjectSearchResultsTimeout = setTimeout(() => {
                    if (this.$route.name !== 'publications' || (this.$route.name === 'publications' &&  (!facet || facet.name !== 'publication_years'))) {
                        this.$parent.clearSearchResults({ resetFacets: false });
                    }
                    switch (this.$route.name) {
                        case 'list':
                            this.$parent.projectListTable.offset = 0;
                            this.$parent.getProjectSearchResults(false);
                            this.getFacets(false);
                            break;
                        case 'charts':
                            if (this.$parent.$refs.Charts.chartType === 'circle') {
                                this.$parent.$refs.Charts.circlesTableData = null;
                                this.$parent.getProjectSearchCirclesData(false);
                            } else {
                                this.$parent.$refs.Charts.goBack();
                                this.$parent.getProjectSearchGraphData(false);
                            }
                            this.getFacets(false);
                            break;
                        case 'map':
                            // this.$parent.getProjectSearchGraphData(false);
                            this.$parent.$refs.googleMap.resetMapFilters();
                            this.$parent.$refs.googleMap.updateMap();
                            this.$parent.$refs.googleMap.getTableData();
                            this.getFacets(false);
                            break;
                        case 'publications':
                            this.$parent.publicationTable.offset = 0;
                            this.$parent.getPublicationResults(false);
                            if (!facet || (facet && facet.name !== 'publication_years')) {
                                this.getFacets(false);
                                this.setPublicationsFacetData(null);
                            }
                            break;
                        case 'patents':
                            this.$parent.patentTable.offset = 0;
                            this.$parent.getPatents(false);
                            this.getFacets(false);
                            break;
                        case 'clinicalStudies':
                            this.$parent.clinicalStudyTable.offset = 0;
                            this.$parent.getClinicalStudies(false);
                            this.getFacets(false);
                            break;
                        case 'news':
                            this.$parent.PressReleaseTable.offset = 0;
                            this.$parent.getAllNewsData();
                            this.getFacets(false);
                            break;
                        default:
                  }
                }, timeout);
            },
            clearSelections (facetName, $e1) {
                $e1.cancelBubble = true;
				gtag('event','Click', {
					'event_category': 'Search Results Facets',
					'event_label': 'Clear facet - ' + facetName,
					'value': 'Clear facet - ' + facetName
				});	

                if ($e1.stopPropagation) {
                    $e1.stopPropagation();
                }
                this.setPublicationsFacetData(null);
                this.facetCriteria[facetName] = [];
                this.facetCriteriaOrg[facetName] = [];
                this.updateSearchResultsFacets(this.facetCriteria);
                // window.scrollTo(0, 0);
                this.updateURL();
                this.$parent.scrollToResultsTop();
                setTimeout(() => {

                    this.getFacets(false);
                    this.$parent.clearSearchResults({resetFacets: false});
                    this.$parent.isPageLoading = true;
                    switch (this.$route.name) {
                        case 'list':
                            this.$parent.projectListTable.offset = 0;
                            this.$parent.getProjectSearchResults(false);
                            break;
                        case 'charts':
                            if (this.$parent.$refs.Charts.chartType === 'circle') {
                                this.$parent.$refs.Charts.circlesTableData = null;
                                this.$parent.getProjectSearchCirclesData(false);
                            } else {
                                this.$parent.$refs.Charts.goBack();
                                this.$parent.getProjectSearchGraphData(false);
                            }
                            break;
                        case 'map':
                            this.$parent.$refs.googleMap.resetMapFilters();
                            this.$parent.$refs.googleMap.updateMap();
                            this.$parent.$refs.googleMap.getTableData();
                            break;
                        case 'publications':
                            this.$parent.getPublicationResults(false);
                            break;
                        case 'patents':
                            this.$parent.getPatents(false);
                            break;
                        case 'clinicalStudies':
                            this.$parent.getClinicalStudies(false);
                            break;
                        case 'news':
                            this.$parent.PressReleaseTable.offset = 0;
                            this.$parent.getAllNewsData();
                            this.getFacets(false);
                            break;
                        default:
                    }
                    this.setPublicationCountNote();
                }, 1)
            },
            changeView (page) {
                var facetToQueryStr = this.generateQueryString(),
                    previousPage = this.$route.name,
                    newRoute;

                if (this.$route.params.search_id) {
                    newRoute = '/search/' + this.$route.params.search_id + '/projects' + (page ? '/' + page : '');// + '?searchMode=' + this.searchType;
                } else {
                    if (this.$route.params.pi_id) {
                        newRoute = '/PISearch/' + this.$route.params.pi_id + '/' + this.$route.params.pi_name + '/projects' + (page ? '/' + page : '');
                    } else if (this.$route.params.po_name) {
                        newRoute = '/POSearch/' + this.$route.params.po_name + '/projects' + (page ? '/' + page : '');
                    }
                }

                if (event.ctrlKey || event.metaKey) {
                    let routeData = this.$router.resolve({path: newRoute, query: facetToQueryStr});
                    window.open(routeData.href, '_blank');
                } else {
                    this.$router.push({path: newRoute, query: facetToQueryStr});
                }

                if (previousPage === 'map') {
                    this.facetLoader = true;
                    this.getFacets(false);
                }

                // window.scrollTo(0, 0);
                this.$parent.scrollToResultsTop();

                // if (!page && !this.searchResults) {
                if (!page) {
                    this.$parent.projectListTable.offset = 0;
                    this.$parent.getProjectSearchResults(false);
                }
            },
            resetFacets () {
                this.setSearchFacetCriteria(null);
                this.setSearchFacetData(null);
                this.facetCriteria = null;
                this.setPublicationsFacetData(null);
                this.setPublicationsFacetCriteria(null);
                this.facetCriteriaOrg = {};
                this.setPublicationCountNote();
            },
            updateURL () {
                var facetToQueryStr = this.generateQueryString(),
                    facets = this.searchFacetData.facets;
                    if (this.$route.query.sort_field) {
                        facetToQueryStr['sort_field'] = this.$route.query.sort_field;
                    }
                    if (this.$route.query.sort_order) {
                        facetToQueryStr['sort_order'] =  this.$route.query.sort_order;
                    }

                if (!facetToQueryStr['legacy'] || facetToQueryStr['legacy'] !== '1') {
                        delete facetToQueryStr['shared'];
                }
				this.$router.push ({ query: facetToQueryStr }).catch(()=>{});
            }
        }
  }

</script>

<style lang="scss">
    @import '@/scss/variables.scss';
    .sidebar {
    .loading {
        opacity: 0.5;
    }

    .back-btn {
        border-radius: 35px;
        border: none;
        padding: 3px 15px;
        background-color: #fff;
        color: $grey-med;
        margin: 10px auto;
        font-size: 15px;
        display: block;
        font-weight: bold;
        outline: none;
        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
        transition: 0.3s;
        cursor: pointer;
        &:hover,
        &:focus {
            box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.35);
        }
        svg {
            width: 16px;
            fill: $grey-med;
        }

        @media screen and (max-width: 1300px) {
            font-size: 13px;
        }
    }
    .no-facet-data {
        padding: 6px 5px 6px 30px;
        line-height: 1em;
        font-size: 14px;
    }
    
    .nav-item {
        display: inline-block;
        width: 33.333%;
        padding: 0 5px;
        margin-right:0;
        &.disabled {
            cursor: not-allowed;
            opacity: 0.6;
        }
    }
    .nav-link {
        position: relative;
        display: inline-block;
        padding: 2px 0 0 0;
        width: 100%;
        text-align: center;
        color: #333;
        font-weight: 500;
        font-size: 16px;
        border-radius: 6px;
        border: none;
        transition: 0.3s;
        overflow: hidden;

		.fa {
			color: #555;
		}

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 35%;
            width: 30%;
            height: 3px;
            background-color: $blue;
            transition: 0.3s;
        }

        &.nav-link-list {
            background-color: transparent;
            &,
            .link-text {
                &:after {
                    background-color: $yellow;
                }
            }
        }

        &.nav-link-charts {
            background-color: transparent;
            &,
            .link-text {
                &:after {
                    background-color: $blue-charts;
                }
            }
        }

        &.nav-link-map {
            background-color: transparent;
            &,
            .link-text {
                &:after {
                    background-color: $teal;
                }
            }
        }

        &.disabled {
            cursor: not-allowed;
        }

        &:hover,
        &:focus,
        &.active {
            background-color: #fff;
            box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25);
            color: $blue;

            &:after {
                left: 0;
                width: 100%;
            }

            .nav-icon {
                fill: $blue;
            }
        }
    }

    .nav-icon {
        $icon-size: 34px;

        display: block;
        margin: 0 auto;

        width: $icon-size;
        height: $icon-size;

        fill: #555;

        transition: 0.3s;
    }

    .nav-icon-filter {
        $icon-size: 18px;

        display: inline-block;
        margin: 0 4px 0 0;

        width: $icon-size;
        height: $icon-size;

        fill: #5778a1;

        vertical-align: middle;
    }

    .link-text {
        position: relative;
        width: auto;
        padding-bottom: 3px;
        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 3px;
            background-color: $yellow;
        }
    }

    #facets {
        .is-active {
            &.custom-control {
                label {
                    padding: 6px 5px 6px 35px;
                    font-size: 15px;
                    color: #20558a;
                    font-weight: bold;
                    span {
                        font-weight: bold;
                    }
                    &:after, &:before {
                        left: 8px;
                    }
                }
            }
        }
        h2 {
            color: $grey;
            margin: 8px 10px 0 10px;
            font-size: 18px;
        }
        .fh-small {
            display: none;
        }

        .collapse,
        .collapsing {
            .collapse,
            .collapsing {
                ul {
                    ul {
                        padding-left: 20px;
                    }
                }
            }
        }

        ul {
            padding: 0;
            list-style: none;
            margin: 0;
        }

        li,
        button {
            width: 100%;
        }

        button {
            text-align: left;
            border: none;
                outline: none;

            &.collapsed {
                padding: .5em 5px .5em 10px;
                text-decoration: none;
            }
            &:hover, &:focus {
                text-decoration: none;
                background-color: #c6dcef;
                color: $blue-nih;
                outline: none;
                box-shadow: none;
            }
            &.not-collapsed {
                background-color: #e4e4e4;
            }
            i {
                color: $facets-arrow-color;
            }
            // background: none;

            &.fac-clear {
                background-color: #fff;
                color: $red;
                font-size: 12px;
                font-weight: 700;
                margin: 0 3px 0 0;
                vertical-align: middle;
                padding: 1px 15px;
                text-transform: uppercase;
                position: relative;
                z-index: 200;
                // display: inline-block;
                min-width: 10px;
                white-space: nowrap;
                cursor: pointer;
                background-image: none;
                border: 1px solid transparent;
                border-radius: 12px;
                text-align: center;
                width: auto;
                float: right;

                &:hover,
                &:focus {
                    background-color: $red;
                    color: #fff;
                }
            }
        }

        .collapse.show {
            background-color: #e4e4e4;
            li {
                &:hover {
                    label {
                        &:before{
                            background-color: $blue-lighter;
                            border-color: $blue-light;
                        }
                    }
                }
            }
        }
        .custom-checkbox {
            .collapse-facet {
                display: inline-block;
                position: relative;
                top: -0.15em;
                width: auto;
                height: 1.25em;
                // margin-bottom: -0.5em;

                &:hover,
                &:focus {
                    background-color: transparent;
                }
            }
        }
    }

    .facets-scroll {
        overflow: auto;
        display: block;
        // TODO: make dynamic in future
        max-height: calc(100vh - 115px);
    }

    .collapse-button {
        position: relative;
        background: none;
        font-weight: 500;

        &:hover,
        &:focus {
            background-color: #c6dcef;
            outline: none;
        }

        &[aria-expanded="true"] {
            > .collapse-icon {
                transform: rotate(90deg);
            }
        }
    }

    .btn-link, a {
        font-weight: bold;
        text-decoration: none;
        &.collapsed {
            svg, i {
                transform: rotate(-90deg);
            }
        }
    }

    .collapse-category {
        padding: 1em 5px 1em 30px;
        font-size: 15px;
        font-weight: 500;
        color: #333;
        line-height: 1.25em;
        // background-color: #dedede;

        .collapse-facet {
            padding: 0.5em 5px 0.5em 50px;
            font-size: 14px;

            .collapse-icon {
                left: 30px;
            }
        }
    }

    .collapse-facet {
        padding: 0.5em 5px 0.5em 30px;
        font-size: 15px;
        font-weight: 700;
        // color: #333;
        color: $blue;

        &,
        + .collapse,
        + .collapsing {
            background-color: #e4e4e4;
            transition: 0.3s;

            li:last-child {
                padding-bottom: 8px;
            }
        }

        &.collapsed {
            &,
            + .collapse,
            + .collapsing {
                background-color: transparent;
            }

            &:hover,
            &:focus {
                background-color: #c6dcef;
            }
        }

        .collapse-icon {
            left: 10px;
        }
    }

    .collapse-icon {
        position: absolute;
        top: calc(50% - 0.5em);
        left: 10px;
        width: 15px;
        height: 15px;
        fill: $facets-arrow-color;
        transition: 0.3s;
    }

    .custom-control {
        display: block;
        position: relative;
        width: 100%;
        padding-left: 0;

        label {
            display: block;
            $line-height: 1em;

            padding: 6px 5px 6px 55px;
            line-height: #{$line-height};
            width: 100%;

            &:before,
            &:after {
                // top: calc(50% - 0.725rem);
                top: calc(#{$line-height} / 2 - 0.725rem + 7px);
                left: 28px;
                // font-size: 12px;
                // width: 1.45em;
                // height: 1.45em;
            }
        }
    }

    .form-check-inline {
        margin: 0;
        // padding: 4px 0;
    }

    .label-text {
        font-size: 14px;
        font-weight: 400;
    }

    .label-count {
        margin-left: 0.4em;
        color: #616161;
        font-size: 12px;
        font-weight: 500;
    }

    .error-message {
        display: block;
        color: #cc4545;
        font-weight: 500;
        border-radius: 4px;
        margin: 15px;
    }

    @media screen and (max-width: $screen-md-min) {
        #facets {
            .collapse:not(.show) {
                display: none;
            }
            .fh-small {
                display: block;
                margin-bottom: 10px;
                a {
                    background-color: #fff;
                    padding: 5px 12px;
                    display: inline-block;
                    border-radius: 3px;
                    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25);
                    &:hover,
                    &:focus {
                        text-decoration: none;
                        background-color: $blue-light;
                        color: #fff;
                        .nav-icon-filter {
                            fill: #fff;
                        }
                    }
                }
            }

            .fh-full {
                display: none;
            }
        }
    }
    }
</style>
